import { defineStore } from 'pinia';
import type { WebformModalState } from '~~/types/vuex/WebformModal';

export const webformModalStore = defineStore('webformModal', {
  state: () => ({ webformState: null as WebformModalState['webformState'] | null }),
  actions: {
    setWebformState(payload: WebformModalState['webformState'] | null) {

      this.webformState = payload; 

    },
  },
});
